import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot} from "@angular/router";
import {Observable, of} from "rxjs";
import {TurnstileService} from "@biletix/core/services/turnstile.service";


/**
 * Cloudflare Turnstile script'ini rota girişinde ISITIR ama navigasyonu BEKLETMEZ.
 *
 * Eskiden resolver script'in `load` olayını bekliyordu: performans sayfası,
 * challenges.cloudflare.com inmeden render edilemiyordu (Lighthouse: uzun
 * navigasyon zinciri, TBT). Token'a yalnızca "sepete ekle" anında ihtiyaç var;
 * TurnstileService.execute() script henüz inmemişse kendisi bekler.
 */
@Injectable({
  providedIn: 'root'
})
export class RecaptchaResolver {

  constructor(private turnstileService: TurnstileService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.turnstileService.preload();
    return of(true);
  }

}
